import { useEffect } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies -- '@cornerstonejs/core' should be listed in the project's dependencies. Run 'npm i -S @cornerstonejs/core' to add it
import { isCornerstoneInitialized } from '@cornerstonejs/core';
import { atom, useSetAtom } from 'jotai';

import {
  initializeCornerstone,
  initializeRenderingEngine,
} from './initializeCornerstone';

export const renderingEngineAtom = atom(false);

/**
 * This hook contains the single source of truth for initializing cornerstone
 * and cornerstone's rendering engine
 */
export const useCornerstoneInitialization = () => {
  const setRenderingEngine = useSetAtom(renderingEngineAtom);

  useEffect(() => {
    const initializeCornerstoneAndRenderingEngine = async () => {
      if (!isCornerstoneInitialized()) {
        await initializeCornerstone();
      }
      const engine = initializeRenderingEngine();
      setRenderingEngine(!!engine);
    };
    initializeCornerstoneAndRenderingEngine();
  }, [setRenderingEngine]);
};
